module.exports = __webpack_public_path__ + "static/img/007.41e472f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-head/007.png
// module id = o7LP
// module chunks = 1